import * as I from "immutable";

import {Order} from "v2/api/Records";
import {apiHouse} from "v2/api/Houses";
import {apiOrderVisit} from "v2/api/OrderVisits";

export const apiOrder = (order) => {
  return new Order({
    ...order,
    house: apiHouse(order.house),
    newVisits: I.List((order.newVisits || []).map(apiOrderVisit)),
    orderVisitTemplates: I.List(order.orderVisitTemplates.map(I.OrderedMap)),
  });
};

export default {
  apiOrder,
};




/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Orders.js
 **/